<template>
  <svg
    :width="width ? width : height ? height : 40"
    :height="height ? height : width ? width : 36"
    viewBox="0 0 40 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >

    <path
      d="M20.183.907A8.622 8.622 0 0 0 11.56 9.53c0 3.85 5.636 10.867 7.795 13.414a1.08 1.08 0 0 0 1.656 0c2.159-2.547 7.794-9.564 7.794-13.414A8.622 8.622 0 0 0 20.183.907zm0 11.497a2.874 2.874 0 1 1-.001-5.748 2.874 2.874 0 0 1 0 5.748zM1.85 15.685a2.19 2.19 0 0 0-1.377 2.033v17.13c0 .775.783 1.304 1.502 1.017l9.447-4.3v-15.95c-.605-1.094-1.1-2.159-1.454-3.177l-8.118 3.247zm18.332 9.835a3.27 3.27 0 0 1-2.499-1.16 72.283 72.283 0 0 1-4.07-5.25v12.454l13.138 4.38V19.11a72.24 72.24 0 0 1-4.07 5.25 3.271 3.271 0 0 1-2.5 1.16zM38.39 11.936l-9.448 4.3v19.708l9.572-3.828a2.19 2.19 0 0 0 1.377-2.034v-17.13c0-.774-.782-1.304-1.501-1.016z"
      :fill="iconColor"
      fill-rule="nonzero"
    />

  </svg>
</template>

<script>
export default {
  name: 'map-view',
  props: {
    iconColor: {
      type: String,
      default: '#ffffff',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
